import React from "react";
import {Modal} from "antd";
import GoogleMapReact from "google-map-react";
import MarkerIcon from "../assets/marker-icon-2x-blue.png";

const AlarmMapModal = ({gps, visible, onClose}) => {
    const mapDefaults = {
        center: {
            lat: gps?.lat || 0,
            lng: gps?.lon || 0,
        },
        zoom: 18,
    };

    const Marker = () => (
        <div style={{transform: "translate(-50%, -100%)"}}>
            <img src={MarkerIcon} alt="Marker Icon" style={{width: "30px", height: "30px"}}/>
        </div>
    );

    return (
        <Modal
            title="GPS Konumu"
            open={visible}
            onCancel={onClose}
            footer={null}
            width={800}
        >
            <div style={{height: "400px", width: "100%"}}>
                <GoogleMapReact
                    bootstrapURLKeys={{key: "AIzaSyC-SvUIH5jgmfFvb5DXjuawroi1CG134ZA"}}
                    center={mapDefaults.center}
                    zoom={mapDefaults.zoom}
                >
                    <Marker lat={gps.lat} lng={gps.lon}/>
                </GoogleMapReact>
            </div>
        </Modal>
    );
};

export default AlarmMapModal;
